import { NgModule } from '@angular/core';
import { GridComponent } from './grid.component';
import { GridTileComponent } from './grid-tile.component';

@NgModule({
  declarations: [GridComponent, GridTileComponent],
  exports: [GridComponent, GridTileComponent],
})
export class GridModule {}
